import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

const styles = css`

    display: flex;
    flex-direction:column;
    width: 100%;
    align-items: center;
    padding-top: 5vh;

  .image {
    margin-top: 10vh;
    width: 100vw;
    max-width: 400px;
  }

  .loadingText {
    padding: 30px;
    font-size: 1.25em;
  }
`
const Loading = styled(({ className, isLoading, delay = 250, loadingImage, loadingText = "Loading...", children }) => {

  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoading(true), delay)
    return (() => clearTimeout(timer))
  }, [delay]);

  return (
    <>
      {isLoading
        ? showLoading
          ? <div className={className}>
            {loadingImage && <img className='image' alt='searching' src={loadingImage} />}
            <div>{loadingText}</div>
          </div>
          : null
        : <>{children}</>
      }
    </>
  )
})`${styles}`;

export default Loading;